export default __webpack_public_path__ + "static/media/avatar_trex5.d6264303.mp3";